import React from "react"
import { withStyles, makeStyles } from "@material-ui/core/styles"
import Button from "@material-ui/core/Button"
import Dialog from "@material-ui/core/Dialog"
import MuiDialogTitle from "@material-ui/core/DialogTitle"
import MuiDialogContent from "@material-ui/core/DialogContent"
import IconButton from "@material-ui/core/IconButton"
import CloseIcon from "@material-ui/icons/Close"
import Typography from "@material-ui/core/Typography"
import Box from "@material-ui/core/Box"

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(5),
    },
    closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
        width: "28px",
        height: "28px",
    },
})

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h5" component="h2" align="center" style={{ fontWeight: 600 }}>
                {children}
            </Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose} size="small">
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    )
})

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(3),
    },
}))(MuiDialogContent)

const useStyles = makeStyles((theme) => ({
    heading: {
        marginBottom: theme.spacing(2),
        marginTop: theme.spacing(3),
    },
}))

export default function WelcomeDialog(props) {
    const { firstVisitModalOpen: open, handleClose } = props
    const classes = useStyles()

    return (
        <Dialog onClose={handleClose} aria-labelledby="welcome" open={open} maxWidth="lg">
            <DialogTitle id="welcome" onClose={handleClose}>
                Welcome to your Project Dashboard
            </DialogTitle>
            <DialogContent>
                <Typography gutterBottom>
                    The project dashboard will help you activate and track projects and will serve to access the results upon project completion.
                </Typography>
                <Typography gutterBottom>
                    To start a new project, follow the next steps:
                </Typography>
                <Typography variant="h6" component="h3" className={classes.heading}>
                    STEP 1
                </Typography>
                <Typography gutterBottom>
                    Add your organisation's department. The participants will be able to select their department once they start their assessment.
                </Typography>
                <Typography variant="h6" component="h3" className={classes.heading}>
                    STEP 2
                </Typography>
                <Typography gutterBottom>
                    Click "Start Project" and select which project you want to activate.
                </Typography>
                <Typography variant="h6" component="h3" className={classes.heading}>
                    STEP 3
                </Typography>
                <Typography gutterBottom>
                    Name your project.
                </Typography>
                <Typography variant="h6" component="h3" className={classes.heading}>
                    STEP 4
                </Typography>
                <Typography gutterBottom>
                    Assign a project sponsor. You can select yourself or someone from your organisation.
                </Typography>
                <Typography variant="h6" component="h3" className={classes.heading}>
                    STEP 5
                </Typography>
                <Typography gutterBottom>
                    Add participants. Review the roles page if you need help deciding whom to add to the project.
                </Typography>
                <Typography variant="h6" component="h3" className={classes.heading}>
                    STEP 6
                </Typography>
                <Typography gutterBottom>
                    Set reminder type and frequency. The non-responsive participants will receive a reminder to complete the assessment.
                </Typography>
                <Typography variant="h6" component="h3" className={classes.heading}>
                    STEP 7
                </Typography>
                <Typography gutterBottom>
                    Review your project details and activate the new project.
                </Typography>

                <Box textAlign="center">
                    <Button autoFocus onClick={handleClose} variant="contained" color="primary">
                        Let&#39;s get started
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    )
}
